export const UPDATE_USER = "updateUser";
export const ORDER_REJECTED = "orderRejected";
export const ORDER_CANCELLED = "orderCancelled";
export const UPDATE_SCROLLER = "updateScroller";
export const CART_UPDATED = "cartUpdated";
export const SIZES_FETCHED = "sizesFetched";
export const DIGITAL_FILES_FETCHED = "digitalFilesFetched";
export const CORPORATIONS_FETCHED = "corporationsFetched";
export const COMMUNITIES_FETCHED = "communitiesFetched";
export const PRESET_DATA_FETCHED = "presetDataFetched";
export const ABOUT_TO_LOGOUT = "aboutToLogout";
export const SESSION_EXPIRED = "sessionExpired";
export const ERROR_UNAUTHENTICATED = "errorUnauthenticated";
export const CALENDAR_EVENTS_SAVED = "calendarEventsSaved";
